import { render, staticRenderFns } from "./View-QPR.vue?vue&type=template&id=2ae89da1"
import script from "./View-QPR.vue?vue&type=script&lang=js"
export * from "./View-QPR.vue?vue&type=script&lang=js"
import style0 from "./View-QPR.vue?vue&type=style&index=0&id=2ae89da1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports